
<template>
  <!--产品分类-->
  <div>
    <!--面包屑-->
    <div class='table-bread'>
      <span class="title">当前位置：</span>
      <a-breadcrumb>
        <span slot="separator" :style="{color: 'red'}">></span>
        <template  v-for="(item, index) of levelList">
          <a-breadcrumb-item @click.native="clickBread(item, index)" :key="index">
            <span v-if="index === levelList.length - 1">{{item.name}}</span>
            <span :style="{ cursor: 'pointer' }" v-else type="link">{{item.name}}</span>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>
    </div>

    <x-tabula
      @resetSearch="resetSearch"
      :dataSource="dataSource"
      rowKey="category_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img  :style="{width: '30px', height: '30px'}" :src="row.images_url" alt="">
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'category',
  data () {
    return {
      levelList: [{ id: '', name: '首页' }],
      searchList: [
        { props: ['keywords'], placeholder: '分类名称', inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.statusList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: '',
        status: '',
        create_date: '',
        parent_id: ''
      },
      tableOptList: [{ text: '新增', icon: 'plus', key: 'addbtn' }],
      rowOptList: [
        {text: '查看子类', handle: (row) => this.showSubCategory(row), key: 'showChildren'},
        {text: '添加子类', handle: (row) => this.toAddChild(row), key: 'addChildren'},
        {text: '修改', handle: (row) => this.toEdit(row.category_id), key: 'edit'},
        [
          {text: '删除', handle: (row) => this.$children[1].showDeleteConfirm(row), key: 'delete'}
        ]
      ],
      columns: [
        { title: 'ID', dataIndex: 'category_id', align: 'left', width: '' },
        { title: '类目名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '标识', dataIndex: 'mark', align: 'left', width: '' },
        { title: '图标', dataIndex: 'images_url', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '创建时间', dataIndex: 'create_desc', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/category/product',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addCategory',
        title: ''
      },
      deleteParam: {
        url: '/category/product',
        param: { pk_key: 'category_id', pk_val: '' },
        title: this.setTitle(),
        key: 'title'
      }
    };
  },
  created () {
    this.setApiUrl();
  },
  mounted () {
  },
  methods: {
    setTitle () {
      let categoryNameObj = { // 类目名称
        productCate: '产品分类',
        locationCate: '位置分类',
        apiCate: 'api分类',
        msgtplCate: '消息分类',
        docCate: '文档分类'
      };
      return categoryNameObj[this.$route.name];
    },
    /* 设置列表接口参数 */
    setApiUrl () {
      this.listApi.url = this.$store.state.categoryListApi[this.$route.name];
      this.deleteParam.url = this.$store.state.categoryListApi[this.$route.name];
      this.addHandleParam.route = this.$store.state.categoryRoute[this.$route.name];
    },
    resetSearch () {
      this.levelList.splice(1, this.levelList.length - 1);
    },
    /* 点击面包屑 */
    clickBread (item, index) {
      let len = this.levelList.length;
      if (index === len - 1) {
        return false;
      } else {
        this.levelList.splice(index + 1, len - (index + 1));
        // this.$children[1].$children[0].handleReset(); // 清空search组件form表单
        this.resetData(this.searchParams);
        this.searchParams.parent_id = item.id;
        this.$children[1].getTableList();
      }
    },
    /* 查看下级 */
    showSubCategory (row) {
      let everySame = this.levelList.every(ele => ele.id !== row.category_id);
      if (everySame) {
        this.levelList.push({
          id: row.category_id,
          name: row.title
        });
        // this.$children[1].$children[0].handleReset(); // 清空search组件form表单
        this.resetData(this.searchParams);
        this.searchParams.parent_id = row.category_id;
        this.$children[1].getTableList();
      }
    },

    /* 进入添加子类 */
    toAddChild (row) {
      let idArr;
      if (row.parent_id.length) {
        idArr = [...row.parent_id, row.category_id];
      } else {
        idArr = [row.category_id];
      }
      this.$router.push({
        name: this.$store.state.categoryRoute[this.$route.name],
        query: { parentId: idArr, title: '添加子类' }
      });
    },
    /* 进入编辑页面 */
    toEdit (id) {
      this.$router.push({
        name: this.$store.state.categoryRoute[this.$route.name],
        query: {id: id, title: '修改分类'}
      });
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/package/pageCompo/category.vue